import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* loadShopDetail() {
  yield takeEvery(actionTypes.MALL_LOAD_SHOP_DETAIL, function*(action) {
    try {
      const response = yield API.mallLoadShopDetails(action.id);
      if (response.data.success && response.data.data.length === 1) {
        yield put(actions.mallLoadShopDetailsSuccess(response.data.data[0]));
      } else {
        alert("Warning: Fail to load shop detail. \n" + response.data.message);
        yield put(actions.mallLoadShopDetailsFail());
      }
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to load shop detail. \n"));
      yield put(actions.mallLoadShopDetailsFail());
    }
  });
}

export default function* mallShopSaga() {
  yield all([fork(loadShopDetail)]);
}
